import useStore from "../../../store"
import { NeutralButton } from "../../common/Buttons"
import ActionConfirmDrawer from "../../common/ActionConfirmDrawer"
import { useTranslation } from "react-i18next"
import { useState } from "react"

export default function MarkUnarbitrated({ unit }) {
  const { t } = useTranslation()
  const markUnitUnarbitrated = useStore((state) => state.markUnitUnarbitrated)
  const markingUnitUnarbitrated = useStore((state) => state.markingUnitUnarbitrated)
  const [isOpen, setIsOpen] = useState(false)

  const handleConfirm = async () => {
    const isMarkedUnarbitrated = await markUnitUnarbitrated(unit)

    if (isMarkedUnarbitrated) {
      setIsOpen(false)
    }
  }

  return(
    <>
      <NeutralButton
        text={t("Mark Unarbitrated")}
        loading={markingUnitUnarbitrated}
        onClick={() => setIsOpen(true)}
        dataTestId="mark-unarbitrated-button"
      />
      <ActionConfirmDrawer
        title={t("Mark Unarbitrated")}
        body={t("Are you sure you want to mark this unit as unarbitrated?")}
        isOpen={isOpen}
        isConfirming={markingUnitUnarbitrated}
        onClose={() => setIsOpen(false)}
        onConfirm={handleConfirm}
        onCancel={() => setIsOpen(false)}
      />
    </>
  )
}
